import { COLORS_CONFIG_BAR } from "@components/widgets/apacheEchart/Commons"
import { getCommonWidget } from "../dashWidgetHelper"
import { commonWidgets, getCmID, SUZUKI_SCALE_3_COLORS } from "./commonWidgetsSuzuki"

export default {
  title: "Zonal Venta Dashboard",
  description: "Dashboard de Zonal Venta",
  backgroundClassName: (filters: any) => {
    return 'epsilon-hero-bg'
  },
  widgets: (filters: FiltersUI) => [
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'lineDetailedByMonthAndGeo',
      title: 'Satisfacción General',
      position: [0, 0],
      size: [4, 3],
      indicator: 'VENTA_SATISFACCION',
      criticalMomentId: getCmID("venta"),
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      title: 'widgets.snVenta',
      position: [0, 4],
      size: [1, 2],
      indicator: 'VENTA_SATISFACCION',
      criticalMomentId: getCmID("venta"),
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'widgets.npsVenta',
      indicator: 'VENTA_NPS',
      position: [1, 4],
      size: [1, 2],
      criticalMomentId: getCmID("venta"),
      extras: {
        periods: 6
      },
      extraConfigs: {
          colors: SUZUKI_SCALE_3_COLORS
      },
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleGaugeByQuestion',
      title: 'widgets.customerJourneyVenta',
      mapper: (data: any, extra: any) => {
        return data.map((item: any) => {
          return {
            ...item,
            label:  'widgets.indicatorId.' + item.groupId
          }
        })
      },
      indicator: 'VENTA_CUSTOMER_JOURNEY',
      position: [0, 6],
      size: [4, 2],
      criticalMomentId: getCmID("venta"),
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByQuestionBest',
      title: 'widgets.bestRotativasVenta',
      position: [0, 8],
      size: [2, 2],
      indicator: 'VENTA_ROTATIVAS',
      criticalMomentId: getCmID("venta"),
      extraConfigs: {
        fontSize: '18px',
        }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByQuestionWorst',
      title: 'widgets.worstRotativasVenta',
      position: [2, 8],
      size: [2, 2],
      indicator: 'VENTA_ROTATIVAS',
      criticalMomentId: getCmID("venta"),
      extraConfigs: {
        fontSize: '18px',
        }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'mapByGeos',
      title: 'widgets.geoLocationMap',
      position: [0, 10],
      size: [2, 2],
      criticalMomentId: getCmID("venta"),
      indicator: 'VENTA_NPS',
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoBest',
      title: 'widgets.bestGeoLocationsVenta',
      position: [2, 10],
      size: [1, 2],
      extraConfigs: {
        fontSize: '18px',
        limit: 3
      },
      indicator: 'VENTA_SATISFACCION',
      criticalMomentId: getCmID("venta"),
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'rankingByGeoWorst',
      title: 'widgets.worstGeoLocationsVenta',
      position: [3, 10],
      size: [1, 2],
      extraConfigs: {
        fontSize: '18px',
        limit: 3,
        backgroundColor: '#501C78',
        titleBackgroundColor: '#db7476',
      },
      indicator: 'VENTA_SATISFACCION',
      criticalMomentId: getCmID("venta"),
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'widgets.sentimentAnalysis',
      position: [0, 12],
      size: [4, 4],
      indicator: 'SENTIMENT',
      criticalMomentId: getCmID("venta"),
    }),
    {
      title: "widgets.zoneGeneralSatisfaction",
      position: [0, 16],
      size: [4, 1],
      config: {
        id: "ranking-zonas",
        type: "rankingIPN",
        indicators: [
          {
            indicator: "VENTA_SATISFACCION",
            keyExtract: ["group", "position", "groupCount"],
            grouped: "geoLocation",
            label: "group",
            value: "position",
            singleton: true,
            sort: { value: "desc" },
            limit: 1,
            extras: {
              aggregation: "rankingPosition",
              rankingPositionScope: 100,
            },
          },
        ],
      },
    },
    {
      title: "widgets.distributorGeneralSatisfaction",
      // [Column, Row]
      position: [0, 17],
      size: [4, 2],
      config: {
        id: "satisfaccion-dist",
        type: "bar",
        fillMode: "",
        //colors: '#f38625',
        colors: COLORS_CONFIG_BAR,
        showValues: true,
        percentageScale: false,
        indicators: [
          {
            indicator: "VENTA_SATISFACCION",
            grouped: "geoLocation",
            keyExtract: ["group", "value"],
            label: "group",
            value: "value",
            singleton: true,
            extras: {
              groupByLevel: 3,
              criticalMomentId: getCmID("venta"),
            },
          },
        ],
      },
    },
    {
      title: "widgets.otherIndicators",
      type: "label",
      position: [0, 19],
      size: [4, 1],
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericSmall',
      title: "widgets.warrantyExplanation",
      position: [0, 20],
      size: [2, 2],
      indicator: 'VENTA_BENEFICIOS',
      mapper: (data) => {
        return data.map((item) => ({
          id: item["group"] == null ? "Indefinido" : item["group"],
          label: item["group"] == null ? "Indefinido" : item["group"],
          value: item["value"],
        }))
      },
      criticalMomentId: getCmID("venta"),
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      title: 'widgets.entregaVenta',
      position: [2, 20],
      size: [1, 2],
      indicator: 'VENTA_ENTREGA',
      criticalMomentId: getCmID("venta"),
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      title: 'widgets.upsellingVenta',
      position: [3, 20],
      size: [1, 2],
      indicator: 'VENTA_ACCESORIOS_ADICIONALES',
      criticalMomentId: getCmID("venta"),
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      title: 'widgets.instalationsVenta',
      position: [0, 22],
      size: [1, 2],
      indicator: 'VENTA_INSTALACIONES',
      criticalMomentId: getCmID("venta"),
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'gaugeGeneric',
      title: 'widgets.confirmacionEntregaVenta',
      position: [1, 22],
      size: [1, 2],
      indicator: 'VENTA_CONFIRMACION_ENTREGA',
      criticalMomentId: getCmID("venta"),
    }),
    {
      title: "widgets.driveTestReasonsVenta",
      // [Column, Row]
      position: [2, 22],
      size: [2, 2],
      config: {
        id: "venta-no-prueba",
        type: "pie",
        fillMode: "",
        colors: ["#015c52", "#33b9ce", "#f38625"],
        showValues: true,
        //percentageScale: false,
        mapper: (data) => {
          return data.map((item) => ({
            id: item["group"] == null ? "Indefinido" : item["group"],
            label: item["group"] == null ? "Indefinido" : item["group"],
            value: item["value"],
          }))
        },
        indicators: [
          {
            indicator: "VENTA_SIN_PRUEBA_MANEJO_MOTIVO",
            //grouped: 'geoLocation',
            keyExtract: ["group", "count", "value"],
            label: "group",
            value: "value",
            singleton: true,
            extras: {
              criticalMomentId: getCmID("venta"),
            },
          },
        ],
      },
    },
    {
      title: "widgets.financingReasonsVenta",
      // [Column, Row]
      position: [0, 24],
      size: [2, 2],
      config: {
        id: "venta-no-financiacion",
        type: "pie",
        fillMode: "",
        colors: ["#015c52", "#33b9ce", "#f38625"],
        showValues: true,
        //percentageScale: false,
        mapper: (data) => {
          return data.map((item) => ({
            id: item["group"] == null ? "Indefinido" : item["group"],
            label: item["group"] == null ? "Indefinido" : item["group"],
            value: item["value"],
          }))
        },
        indicators: [
          {
            indicator: "VENTA_SIN_FINANCIAMIENTO_MOTIVO",
            //grouped: 'geoLocation',
            keyExtract: ["group", "count", "value"],
            label: "group",
            value: "value",
            singleton: true,
            extras: {
              criticalMomentId: getCmID("venta"),
            },
          },
        ],
      },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCountWithLinks',
      title: 'Nube de Palabras / Frecuencia en comentarios',
      position: [0, 26],
      size: [4, 2],
      criticalMomentId: getCmID("venta"),
    }),
  ],
} as DasboardConfig
